<template>
  <div class="inline-flex items-center flex-grow">
    <product-label-group :product="product" :base-properties="baseProperties" class="mr-1" />
    <span v-if="year" class="text-sm text-gray-80" :qaid="`${qaid}modelYear`">{{ year }}</span>
    <trek-link
      v-if="product.spectrumUrl && product.customProductStartingPoint"
      button
      text
      small
      underline
      :href="productUrlCustomizerOpen"
    >
      <span v-html="bp('customize')" />
    </trek-link>
  </div>
</template>
<script>
import TrekLink from '@/components/TrekLink';
import {qaidMixin} from '@/utils/qaid-helper';
import ProductLabelGroup from '@/components/ProductLabelGroup';

export default {
  name: 'ProductLabelYear',
  components: {ProductLabelGroup, TrekLink},
  mixins: [qaidMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    productUrlCustomizerOpen: {
      type: String,
      default: '',
      required: false,
    },
  },
  computed: {
    year() {
      if (this.product.marketingModelYear) {
        return this.product.marketingModelYear;
      } else if (this.product.bike && this.product.modelYearRange) {
        return this.product.modelYearRange;
      }
      return '';
    },
  },
};
</script>
